{
    "translation": {
        "welcome": "Willkommen",
        "home": "Startseite",
        "find_pro": "Profi finden",
        "admin": "Admin",
        "my_space": "Mein Bereich",
        "login": "Anmelden",
        "logout": "Abmelden",
        "search_placeholder": "Friseur, Barbier, Maniküre...",
        "hero_welcome": "Willkommen bei OpenGlow",
        "hero_slogan": "Exzellenz zum Greifen nah.",
        "hero_desc": "Buchen Sie Ihre Beauty- und Wellnessbehandlungen in wenigen Klicks. Einfach, schnell und elegant.",
        "hero_title": "Buchen Sie Ihren Schönheitstermin",
        "hero_subtitle": "Finden Sie die besten Profis in Ihrer Nähe.",
        "search_btn": "Suchen",
        "popular_services": "Beliebte Dienstleistungen",
        "footer_rights": "Alle Rechte vorbehalten.",
        "footer_about_us": "Uber uns",
        "legal_mentions": "Impressum",
        "cgp": "Allgemeine Geschäftsbedingungen",
        "feature_search_title": "Suchen",
        "feature_search_desc": "Finden Sie die besten Salons und Experten in Ihrer Nähe",
        "feature_book_title": "Buchen",
        "feature_book_desc": "Wählen Sie Ihren idealen Termin in Sekunden",
        "feature_enjoy_title": "Genießen",
        "feature_enjoy_desc": "Erleben Sie ein einzigartiges und entspannendes Schönheitserlebnis",
        "featured_pros_title": "Hervorgehobene Profis",
        "reviews_count": "Bewertungen",
        "client_space": "KUNDENBEREICH",
        "my_bookings": "Meine Buchungen",
        "explore_map": "Karte erkunden",
        "edit_photo": "Foto bearbeiten",
        "photo_updated": "Profilbild aktualisiert!",
        "error_upload": "Fehler beim Hochladen des Fotos.",
        "search_action": "Suchen",
        "filters_all": "Alle",
        "filter_sort": "Filter",
        "filter_distance_nearest": "Distanz: am nächsten",
        "filter_rating_highest": "Bewertung: höchste",
        "filter_reviews_most": "Bewertungen: die meisten",
        "filter_name_az": "Name: A-Z",
        "filter_min_rating": "Mindestbewertung",
        "filter_max_distance": "Maximale Distanz",
        "show_filters": "Filter anzeigen",
        "hide_filters": "Filter ausblenden",
        "map_style": "Stil",
        "map_enable_location_filter": "Aktivieren Sie den Standortfilter nach Distanz",
        "profession_hairdresser": "Friseur",
        "profession_esthetician": "Kosmetiker",
        "profession_barber": "Barbier",
        "profession_manicure": "Maniküre",
        "profession_masseur": "Masseur",
        "settings_title": "Einstellungen",
        "settings_back": "Zurück",
        "settings_section_appearance": "Erscheinungsbild",
        "settings_theme_intro": "Wählen Sie das App-Design.",
        "settings_theme_classic": "Schwarz & Weiß",
        "settings_theme_ocean": "Ozean",
        "settings_theme_rose": "Rosa",
        "settings_theme_dark": "Dunkel",
        "settings_theme_night": "Nacht",
        "settings_compact_mode": "Kompaktmodus",
        "settings_compact_mode_sub": "Reduziert den Abstand auf dieser Seite",
        "settings_section_notifications": "Benachrichtigungen",
        "settings_notif_email": "Buchungs-E-Mails",
        "settings_notif_email_sub": "Bestätigungen und Terminerinnerungen",
        "settings_notif_push": "Benachrichtigungszentrum",
        "settings_notif_push_sub": "In-App-Benachrichtigungen",
        "settings_notif_marketing": "Neuigkeiten & Angebote",
        "settings_notif_marketing_sub": "Produktupdates und Aktionen",
        "settings_section_account": "Konto",
        "settings_account_profile": "Profil",
        "settings_account_email_label": "E-Mail-Adresse",
        "settings_not_connected": "Nicht verbunden",
        "settings_section_security": "Sicherheit",
        "settings_pwd_title": "Passwort ändern",
        "settings_pwd_hint": "Wählen Sie ein starkes Passwort (12+ Zeichen, Großbuchstabe, Zahl, Symbol)",
        "settings_pwd_current": "Aktuelles Passwort",
        "settings_pwd_new": "Neues Passwort",
        "settings_pwd_confirm": "Neues Passwort bestätigen",
        "settings_pwd_submit": "Passwort speichern",
        "settings_pwd_submitting": "Wird gespeichert…",
        "about_title": "Uber uns",
        "about_intro": "OpenGlow ist eine franzosische Plattform, die die Verbindung zwischen Kunden und Beauty-Profis vereinfacht.",
        "about_mission_title": "Unsere Mission",
        "about_mission_text": "Jeder Person helfen, schnell einen vertrauenswurdigen Profi in der Nahe zu finden, mit einer einfachen, transparenten und modernen Buchungserfahrung.",
        "about_build_title": "Was wir aufbauen",
        "about_build_item_1": "Einen klaren Kundenbereich zum Suchen, Buchen und Verfolgen von Terminen.",
        "about_build_item_2": "Einen Profi-Bereich zur Verwaltung von Planung, Leistungen, Bewertungen und Ankundigungen.",
        "about_values_title": "Unsere Werte",
        "about_values_simple_label": "Einfachheit:",
        "about_values_simple_text": "eine schnelle und leicht verstandliche Oberflache fur alle.",
        "about_values_trust_label": "Vertrauen:",
        "about_values_trust_text": "klare Informationen und verifizierte Profile.",
        "about_values_respect_label": "Respekt:",
        "about_values_respect_text": "Schutz personenbezogener Daten und ein verantwortungsvoller Ansatz.",
        "about_values_exigence_label": "Anspruch:",
        "about_values_exigence_text": "kontinuierliche Verbesserung der Nutzererfahrung.",
        "about_contact_title": "Kontakt",
        "about_contact_line_1": "Haben Sie eine Frage oder brauchen Sie Hilfe?",
        "about_contact_line_2": "Nutzen Sie bitte den internen Chat der Website fur eine schnellere Antwort.",
        "about_contact_line_3": "Fur andere Anliegen schreiben Sie uns an",
        "settings_show_pwd": "Anzeigen",
        "settings_hide_pwd": "Verbergen",
        "passwords_mismatch": "Die Passwörter stimmen nicht überein.",
        "password_change_success": "Passwort erfolgreich geändert.",
        "password_change_error": "Fehler beim Ändern des Passworts.",
        "network_error_retry": "Netzwerkfehler. Bitte erneut versuchen."
    }
}